import "jquery";
import "bootstrap";
import { tns } from "tiny-slider/src/tiny-slider";
import simpleParallax from "simple-parallax-js";

// Detect whether the user is running IE11
let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

function animate(obj) {
  let direction = obj.dataset.direction;
  let type = obj.dataset.type;
  let initVal = parseInt(obj.dataset.start);
  let lastVal = parseInt(obj.dataset.end);
  let appendVal = obj.dataset.append;
  let duration = parseInt(obj.dataset.duration);
  let startTime = null;
  let currentTime = Date.now();

  const step = (currentTime) => {
    startTime = !startTime ? currentTime : startTime;
    const progress = Math.min((currentTime - startTime) / duration, 1);
    let val = Math.floor(progress * (lastVal - initVal) + initVal);

    obj.innerHTML =
      (type == "num" ? val.toLocaleString("en-US") : val) +
      (progress === 1 ? appendVal : "");

    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      window.cancelAnimationFrame(window.requestAnimationFrame(step));
    }
  };

  window.requestAnimationFrame(step);
}

window.addEventListener("DOMContentLoaded", (event) => {
  let scrollLeft =
    window.pageXOffset !== undefined
      ? window.pageXOffset
      : (document.documentElement || document.body.parentNode || document.body)
        .scrollLeft;
  let scrollTop =
    window.pageYOffset !== undefined
      ? window.pageYOffset
      : (document.documentElement || document.body.parentNode || document.body)
        .scrollTop;

  // Hover navbar
  let mainNavMenu = document.querySelector("#menu-primary");
  let primaryNavigation = document.querySelector("#primaryNavigationBar");
  // Search bar
  let searchBar = document.querySelector(".search-bar");

  // Add dropshadow on sticky nav
  window.addEventListener("scroll", (event) => {
    let scrollTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
          document.documentElement ||
          document.body.parentNode ||
          document.body
        ).scrollTop;
    if (scrollTop >= 100) {
      primaryNavigation.classList.add("shadow-lg");
    } else if (scrollTop <= 0) {
      primaryNavigation.classList.remove("shadow-lg");
    }
  });

  // Animation
  const animationObserver = new IntersectionObserver((entries) => {
    // Loop over the entries
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        let factFigure = entry.target.querySelector(".fact-figure");
        animate(factFigure);
      }
    });
  });

  // Parallax
  const parallaxObserver = new IntersectionObserver((entries) => {
    // Loop over the entrie
    entries.forEach((entry) => {
      const fromRight = entry.target.querySelector(".from-right");
      const fromLeft = entry.target.querySelector(".from-left");

      // If the element is visible
      if (entry.isIntersecting) {
        // Add the animation class
        if (fromRight && !fromRight.classList.contains("slide-left")) {
          fromRight.classList.add("slide-left");
        }
        if (fromLeft && !fromLeft.classList.contains("slide-right")) {
          fromLeft.classList.add("slide-right");
        }
        return;
      }

      // We're not intersecting, so remove the class!
      if (fromRight) {
        fromRight.classList.remove("slide-left");
      }
      if (fromLeft) {
        fromLeft.classList.remove("slide-right");
      }
    });
  });

  document.querySelectorAll(".block-modal-video").forEach((block) => {
    block.querySelectorAll("div[id^=videoModal-]").forEach((modal) => {
      const videoEmbed = modal.querySelector(".modal-body iframe");
      const src = videoEmbed.src;
      modal.addEventListener('hide.bs.modal', event => {
        videoEmbed.src = '';
      });

      modal.addEventListener('shown.bs.modal', event => {
        videoEmbed.src = src;
      });

    });
  });

  document.querySelectorAll(".block-carousel-gallery").forEach((block) => {
    block.querySelectorAll(".tiny-slider").forEach((slider) => {
      let tnsData = slider.dataset;

      let galleryConfig = {
        container: slider,
        mode: "carousel",
        loop: JSON.parse(tnsData.tnsLoop),
        speed: JSON.parse(tnsData.tnsSpeed),
        autoplay: JSON.parse(tnsData.tnsAutoplay),
        autoplayButtonOutput: JSON.parse(tnsData.tnsAutoplayButton),
        autoplayTimeout: JSON.parse(tnsData.tnsAutoplayTimeout),
        center: JSON.parse(tnsData.tnsCenter),
        fixedWidth: JSON.parse(tnsData.tnsFixedWidth),
        nav: JSON.parse(tnsData.tnsNav),
        controls: JSON.parse(tnsData.tnsControls),
        controlsContainer: document.querySelector(tnsData.tnsControlsContainer),
        prevButton: document.querySelector(tnsData.tnsPrevButton),
        nextButton: document.querySelector(tnsData.tnsNextButton),
        controlsPosition: "bottom",
        dots: document.querySelector(tnsData.tnsDots),
        items: JSON.parse(tnsData.tnsItems),
        slideBy: JSON.parse(tnsData.tnsSlideBy),
        lazyload: true,
      };
      tns(galleryConfig);
    });
  });

  document.querySelectorAll(".block-carousel-card, .block-carousel-news-card, .block-carousel-publication, .block-carousel-images").forEach((block) => {
    block.querySelectorAll(".tiny-slider").forEach((slider) => {
      let tnsData = slider.dataset;

      let carouselConfig = {
        container: slider,
        mode: "carousel",
        autoHeight: Boolean(JSON.parse(tnsData.tnsAutoHeight)),
        autoWidth: Boolean(JSON.parse(tnsData.tnsAutoWidth)),
        controls: Boolean(JSON.parse(tnsData.tnsShowControls)),
        controlsContainer: document.querySelector(tnsData.tnsControlsContainer),
        controlsPosition: "bottom",
        prevButton: document.querySelector(tnsData.tnsPrevButton),
        nextButton: document.querySelector(tnsData.tnsNextButton),
        nav: false,
        dots: false,
        items: 1,
        slideBy: JSON.parse(tnsData.tnsSlideBy),
        lazyload: true,
        responsive: {
          576: {
            items: 1,
          },
          768: {
            items: JSON.parse(tnsData.tnsItems),
          },
        },
      };
      let tnsSlider = tns(carouselConfig);
    });
  });

  document.querySelectorAll(".block-carousel-image-thumbnails, .block-carousel-video-thumbnails, .lightbox-slider").forEach((block) => {
    block.querySelectorAll(".tiny-slider").forEach((slider) => {
      let tnsData = slider.dataset;

      let carouselConfig = {
        container: slider,
        mode: "carousel",
        center: true,
        controls: Boolean(JSON.parse(tnsData.tnsShowControls)),
        controlsContainer: document.querySelector(tnsData.tnsControlsContainer),
        controlsPosition: "bottom",
        prevButton: document.querySelector(tnsData.tnsPrevButton),
        nextButton: document.querySelector(tnsData.tnsNextButton),
        navAsThumbnails: true,
        navContainer: document.querySelector(tnsData.tnsNavContainer),
        dots: false,
        items: 1,
        slideBy: 1,
        lazyload: true
      };
      tns(carouselConfig);
    });
  });

  document.querySelector(".search-bar-toggle").addEventListener("click", (event) => {
    searchBar.classList.toggle("d-none");
  });

  if (window.innerWidth > 768) {
    document.querySelectorAll(".block-animated-fact-figure").forEach((item) => {
      animationObserver.observe(item);
    });

    document.querySelectorAll(".scroll-slide-in").forEach((item) => {
      parallaxObserver.observe(item);
    });

    /**
    * Parallax images in feature blocks
    */
    if (!isIE11 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var ParallaxBlocks = document.querySelectorAll(".is-style-parallax");
      // console.log(ParallaxBlocks, "parallax blocks");

      ParallaxBlocks.forEach((block) => {
        // console.log(block.dataset,"block");
        new simpleParallax(block.querySelector(".parallax-img"), {
          overflow:
            block.dataset.overflow !== undefined ? block.dataset.overflow : true,
          scale: block.dataset.scale !== undefined ? block.dataset.scale : 2,
          orientation:
            block.dataset.orientation !== undefined
              ? block.dataset.orientation
              : "up",
          delay: 0,
          maxTransition:
            block.dataset.maxTransition !== undefined
              ? block.dataset.maxTransition
              : "100%",
        });
      });
    }
  }

  if (window.innerWidth > 992) {
    mainNavMenu.querySelectorAll(".nav-item").forEach((everyitem) => {
      everyitem.addEventListener("mouseover", function (e) {
        let el_link = this.querySelector("a[data-bs-toggle]");

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.ariaExpanded = "true";
          el_link.classList.add("show");
          nextEl.setAttribute("data-bs-popper", "none");
          nextEl.classList.add("show");
        }
      });
      everyitem.addEventListener("mouseleave", function (e) {
        let el_link = this.querySelector("a[data-bs-toggle]");

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.ariaExpanded = "false";
          el_link.classList.remove("show");
          nextEl.removeAttribute("data-bs-popper");
          nextEl.classList.remove("show");
        }
      });
    });
  }
});
